import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import hash from 'object-hash';

import getCarParameters from '@/features/cars/helpers/getCarParameters';
import { useAppSelector } from '@/features/hooks';
import { rootQueriesApi, rootSelectors } from '@/features/store';
import useAppFetch from '@/hooks/useAppFetch';

const useCarData = () => {
  const { id } = useParams();

  const config = useAppSelector(rootSelectors.config.configSelector);

  const parameters = useMemo(() => {
    return getCarParameters(config, id);
  }, [config, id]);

  const isSkip = !parameters.itemId;

  const [fetchCar, queryResult] = rootQueriesApi.cars.useLazyGetCarQuery();

  useAppFetch(
    async () => {
      await fetchCar(parameters, true).unwrap();
    },
    [parameters],
    { ssr: hash(parameters), skip: isSkip },
  );

  return {
    ...queryResult,
    data: queryResult?.data,
  };
};

export default useCarData;
